import {
  createProduct as publicCreateProduct,
  createProductWithInventory as publicCreateProductWithInventory,
  updateProduct as publicUpdateProduct,
  updateProductWithInventory as publicUpdateProductWithInventory,
  bulkCreateProducts as publicBulkCreateProducts,
  bulkCreateProductsWithInventory as publicBulkCreateProductsWithInventory,
  bulkUpdateProducts as publicBulkUpdateProducts,
  bulkUpdateProductsWithInventory as publicBulkUpdateProductsWithInventory,
  bulkUpdateProductsByFilter as publicBulkUpdateProductsByFilter,
  deleteProduct as publicDeleteProduct,
  bulkDeleteProducts as publicBulkDeleteProducts,
  bulkDeleteProductsByFilter as publicBulkDeleteProductsByFilter,
  getProduct as publicGetProduct,
  getProductBySlug as publicGetProductBySlug,
  searchProducts as publicSearchProducts,
  queryProducts as publicQueryProducts,
  typedQueryProducts as publicTypedQueryProducts,
  countProducts as publicCountProducts,
  bulkUpdateProductVariantsByFilter as publicBulkUpdateProductVariantsByFilter,
  bulkAdjustProductVariantsByFilter as publicBulkAdjustProductVariantsByFilter,
  bulkAddInfoSectionsToProductsByFilter as publicBulkAddInfoSectionsToProductsByFilter,
  bulkAddInfoSectionsToProducts as publicBulkAddInfoSectionsToProducts,
  bulkRemoveInfoSectionsFromProductsByFilter as publicBulkRemoveInfoSectionsFromProductsByFilter,
  bulkRemoveInfoSectionsFromProducts as publicBulkRemoveInfoSectionsFromProducts,
  bulkAddProductsToCategoriesByFilter as publicBulkAddProductsToCategoriesByFilter,
  bulkRemoveProductsFromCategoriesByFilter as publicBulkRemoveProductsFromCategoriesByFilter,
  getAllProductsCategory as publicGetAllProductsCategory,
  bulkUpdateProductTags as publicBulkUpdateProductTags,
  bulkUpdateProductTagsByFilter as publicBulkUpdateProductTagsByFilter,
} from './stores-catalog-v3-product-products-v-3.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ProductsQueryBuilder,
  QueryProductsOptions,
  V3ProductQuery,
  typedQueryProducts as universalTypedQueryProducts,
} from './stores-catalog-v3-product-products-v-3.universal.js';
import { onProductCreated as publicOnProductCreated } from './stores-catalog-v3-product-products-v-3.public.js';
import { onProductDeleted as publicOnProductDeleted } from './stores-catalog-v3-product-products-v-3.public.js';
import { onProductUpdated as publicOnProductUpdated } from './stores-catalog-v3-product-products-v-3.public.js';

function customQueryProducts(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryProductsOptions) =>
      publicQueryProducts(httpClient)(options),
    typedQueryFunction: (
      query: V3ProductQuery,
      options?: QueryProductsOptions
    ) => publicTypedQueryProducts(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: V3ProductQuery,
    options?: QueryProductsOptions
  ): ReturnType<typeof universalTypedQueryProducts>;
  function overloadedQuery(
    options?: QueryProductsOptions
  ): ProductsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: V3ProductQuery | QueryProductsOptions,
    options?: QueryProductsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createProduct: MaybeContext<
  BuildRESTFunction<typeof publicCreateProduct> & typeof publicCreateProduct
> = /*#__PURE__*/ createRESTModule(publicCreateProduct);
export const createProductWithInventory: MaybeContext<
  BuildRESTFunction<typeof publicCreateProductWithInventory> &
    typeof publicCreateProductWithInventory
> = /*#__PURE__*/ createRESTModule(publicCreateProductWithInventory);
export const updateProduct: MaybeContext<
  BuildRESTFunction<typeof publicUpdateProduct> & typeof publicUpdateProduct
> = /*#__PURE__*/ createRESTModule(publicUpdateProduct);
export const updateProductWithInventory: MaybeContext<
  BuildRESTFunction<typeof publicUpdateProductWithInventory> &
    typeof publicUpdateProductWithInventory
> = /*#__PURE__*/ createRESTModule(publicUpdateProductWithInventory);
export const bulkCreateProducts: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateProducts> &
    typeof publicBulkCreateProducts
> = /*#__PURE__*/ createRESTModule(publicBulkCreateProducts);
export const bulkCreateProductsWithInventory: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateProductsWithInventory> &
    typeof publicBulkCreateProductsWithInventory
> = /*#__PURE__*/ createRESTModule(publicBulkCreateProductsWithInventory);
export const bulkUpdateProducts: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateProducts> &
    typeof publicBulkUpdateProducts
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateProducts);
export const bulkUpdateProductsWithInventory: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateProductsWithInventory> &
    typeof publicBulkUpdateProductsWithInventory
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateProductsWithInventory);
export const bulkUpdateProductsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateProductsByFilter> &
    typeof publicBulkUpdateProductsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateProductsByFilter);
export const deleteProduct: MaybeContext<
  BuildRESTFunction<typeof publicDeleteProduct> & typeof publicDeleteProduct
> = /*#__PURE__*/ createRESTModule(publicDeleteProduct);
export const bulkDeleteProducts: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteProducts> &
    typeof publicBulkDeleteProducts
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteProducts);
export const bulkDeleteProductsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteProductsByFilter> &
    typeof publicBulkDeleteProductsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteProductsByFilter);
export const getProduct: MaybeContext<
  BuildRESTFunction<typeof publicGetProduct> & typeof publicGetProduct
> = /*#__PURE__*/ createRESTModule(publicGetProduct);
export const getProductBySlug: MaybeContext<
  BuildRESTFunction<typeof publicGetProductBySlug> &
    typeof publicGetProductBySlug
> = /*#__PURE__*/ createRESTModule(publicGetProductBySlug);
export const searchProducts: MaybeContext<
  BuildRESTFunction<typeof publicSearchProducts> & typeof publicSearchProducts
> = /*#__PURE__*/ createRESTModule(publicSearchProducts);
export const countProducts: MaybeContext<
  BuildRESTFunction<typeof publicCountProducts> & typeof publicCountProducts
> = /*#__PURE__*/ createRESTModule(publicCountProducts);
export const bulkUpdateProductVariantsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateProductVariantsByFilter> &
    typeof publicBulkUpdateProductVariantsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateProductVariantsByFilter);
export const bulkAdjustProductVariantsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkAdjustProductVariantsByFilter> &
    typeof publicBulkAdjustProductVariantsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkAdjustProductVariantsByFilter);
export const bulkAddInfoSectionsToProductsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkAddInfoSectionsToProductsByFilter> &
    typeof publicBulkAddInfoSectionsToProductsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkAddInfoSectionsToProductsByFilter);
export const bulkAddInfoSectionsToProducts: MaybeContext<
  BuildRESTFunction<typeof publicBulkAddInfoSectionsToProducts> &
    typeof publicBulkAddInfoSectionsToProducts
> = /*#__PURE__*/ createRESTModule(publicBulkAddInfoSectionsToProducts);
export const bulkRemoveInfoSectionsFromProductsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkRemoveInfoSectionsFromProductsByFilter> &
    typeof publicBulkRemoveInfoSectionsFromProductsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkRemoveInfoSectionsFromProductsByFilter
);
export const bulkRemoveInfoSectionsFromProducts: MaybeContext<
  BuildRESTFunction<typeof publicBulkRemoveInfoSectionsFromProducts> &
    typeof publicBulkRemoveInfoSectionsFromProducts
> = /*#__PURE__*/ createRESTModule(publicBulkRemoveInfoSectionsFromProducts);
export const bulkAddProductsToCategoriesByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkAddProductsToCategoriesByFilter> &
    typeof publicBulkAddProductsToCategoriesByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkAddProductsToCategoriesByFilter);
export const bulkRemoveProductsFromCategoriesByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkRemoveProductsFromCategoriesByFilter> &
    typeof publicBulkRemoveProductsFromCategoriesByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkRemoveProductsFromCategoriesByFilter
);
export const getAllProductsCategory: MaybeContext<
  BuildRESTFunction<typeof publicGetAllProductsCategory> &
    typeof publicGetAllProductsCategory
> = /*#__PURE__*/ createRESTModule(publicGetAllProductsCategory);
export const bulkUpdateProductTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateProductTags> &
    typeof publicBulkUpdateProductTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateProductTags);
export const bulkUpdateProductTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateProductTagsByFilter> &
    typeof publicBulkUpdateProductTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateProductTagsByFilter);
export const queryProducts: MaybeContext<
  BuildRESTFunction<typeof customQueryProducts> & typeof customQueryProducts
> = /*#__PURE__*/ createRESTModule(customQueryProducts);
/** */
export const onProductCreated: BuildEventDefinition<
  typeof publicOnProductCreated
> &
  typeof publicOnProductCreated = createEventModule(publicOnProductCreated);
/**
 * Triggered when a product is deleted.
 */
export const onProductDeleted: BuildEventDefinition<
  typeof publicOnProductDeleted
> &
  typeof publicOnProductDeleted = createEventModule(publicOnProductDeleted);
/**
 * Triggered when a product is updated.
 */
export const onProductUpdated: BuildEventDefinition<
  typeof publicOnProductUpdated
> &
  typeof publicOnProductUpdated = createEventModule(publicOnProductUpdated);

export {
  NodeType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  Type,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  MediaType,
  ProductOptionRenderType,
  ChoiceType,
  ModifierRenderType,
  InventoryAvailabilityStatus,
  PreorderStatus,
  ProductPreorderAvailability,
  ProductType,
  MeasurementUnit,
  WeightUnit,
  FileType,
  SubscriptionFrequency,
  DiscountType,
  BackgroundType,
  GradientType,
  SketchDataVariant,
  Origin,
  BannerPosition,
  LayoutDataBackgroundType,
  BackdropType,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  DimensionsUnit,
  UserCriteria,
  Enum,
  State,
  WebhookIdentityType,
  SingleEntityOpsRequestedFields,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
  RequestedFields,
  CommonSortOrder,
  ValueAggregationSortType,
  ValueAggregationSortDirection,
  ValueAggregationMissingValues,
  CommonScalarType,
  NestedAggregationNestedAggregationType,
  DateHistogramAggregationInterval,
  CommonAggregationType,
  SearchDetailsMode,
  VariantsOpsRequestedFields,
  RoundingStrategy,
  AvailabilityStatus,
  EventType,
  CommonSearchDetailsMode,
  WixCommonSortOrder,
  AggregationValueAggregationSortType,
  AggregationValueAggregationSortDirection,
  AggregationValueAggregationMissingValues,
  WixCommonScalarType,
  AggregationNestedAggregationNestedAggregationType,
  AggregationDateHistogramAggregationInterval,
  WixCommonAggregationType,
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy,
} from './stores-catalog-v3-product-products-v-3.universal.js';
export {
  V3Product,
  V3ProductTypedPropertiesOneOf,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Border,
  Colors,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  V1Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  TableDataDimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  LayoutCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  Media,
  ProductMedia,
  ProductMediaSetByOneOf,
  ProductMediaMediaOneOf,
  VideoResolution,
  Thumbnail,
  MediaItemsInfo,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  ConnectedOption,
  ConnectedOptionOptionSettingsOneOf,
  ChoicesSettings,
  ConnectedOptionChoice,
  ConnectedOptionChoiceValueOneOf,
  MultipleColors,
  ConnectedModifier,
  ConnectedModifierModifierSettingsOneOf,
  FreeTextSettings,
  ModifierChoicesSettings,
  ConnectedModifierChoice,
  ConnectedModifierChoiceValueOneOf,
  V3Brand,
  InfoSection,
  Ribbon,
  ProductCategoriesInfo,
  ProductCategory,
  ProductCategoryIdsInfo,
  PriceRange,
  FixedMonetaryAmount,
  Inventory,
  PhysicalProperties,
  PricePerUnitSettings,
  WeightRange,
  PricePerUnitRange,
  PricePerUnitRangePricePerUnit,
  WeightMeasurementUnitInfo,
  BreadcrumbsInfo,
  BreadCrumb,
  VariantsInfo,
  Variant,
  VariantTypedPropertiesOneOf,
  OptionChoice,
  OptionChoiceIds,
  OptionChoiceNames,
  PriceInfo,
  RevenueDetails,
  VariantPhysicalProperties,
  PricePerUnit,
  VariantDigitalProperties,
  SecuredMedia,
  SubscriptionPricesInfo,
  SubscriptionPrice,
  SubscriptionPricePerUnit,
  InventoryStatus,
  ExtendedFields,
  SubscriptionDetails,
  Subscription,
  SubscriptionCyclesOneOf,
  SubscriptionDiscount,
  SubscriptionDiscountDiscountOneOf,
  VariantSummary,
  MinVariantPriceInfo,
  Gradient,
  Stop,
  Background,
  SketchData,
  Banner,
  LayoutDataBackground,
  Backdrop,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  CheckboxListData,
  ListItemNodeData,
  MediaReferences,
  MediaReference,
  MediaReferenceIdentifierOneOf,
  Dimensions,
  PurchaseEligibility,
  DiscountInfo,
  Tags,
  TagList,
  UpdateDocumentsEvent,
  UpdateDocumentsEventOperationOneOf,
  DocumentUpdateOperation,
  IndexDocument,
  DocumentPayload,
  DocumentImage,
  DeleteByIdsOperation,
  DeleteByFilterOperation,
  UpdateByFilterOperation,
  UpdateExistingOperation,
  ProductTagsModified,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  SearchIndexingNotification,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  DoNotCallCreateProductRequest,
  DoNotCallCreateProductResponse,
  DuplicateRibbonErrorData,
  DuplicateMediaIdAssignedToProduct,
  GetProductRequest,
  GetProductResponse,
  GetProductBySlugRequest,
  GetProductBySlugResponse,
  DoNotCallUpdateProductRequest,
  DoNotCallUpdateProductResponse,
  VariantsRemoved,
  UnsupportedFieldMasks,
  DeleteProductRequest,
  DeleteProductResponse,
  SearchProductsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Sorting,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  CursorPaging,
  SearchProductsResponse,
  CursorPagingMetadata,
  Cursors,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  SearchRelatedProductsRequest,
  SearchRelated,
  SearchRelatedDetails,
  SearchRelatedProductsResponse,
  EventuallyConsistentQueryProductsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  EventuallyConsistentQueryProductsResponse,
  QueryProductsRequest,
  QueryProductsResponse,
  DeprecatedSearchProductsWithOffsetRequest,
  PlatformOffsetSearch,
  PlatformOffsetSearchPagingMethodOneOf,
  CommonSorting,
  CommonAggregation,
  CommonAggregationKindOneOf,
  RangeAggregationRangeBucket,
  ValueAggregationIncludeMissingValuesOptions,
  AggregationValueAggregation,
  AggregationValueAggregationOptionsOneOf,
  AggregationRangeAggregation,
  AggregationScalarAggregation,
  AggregationDateHistogramAggregation,
  NestedAggregationNestedAggregationItem,
  NestedAggregationNestedAggregationItemKindOneOf,
  AggregationNestedAggregation,
  GroupByAggregation,
  GroupByAggregationKindOneOf,
  CommonSearchDetails,
  PlatformPaging,
  DeprecatedSearchProductsWithOffsetResponse,
  PagingMetadata,
  RetrieveVariantsRequest,
  ProductVariantIds,
  VariantsCursorPaging,
  RetrieveVariantsResponse,
  ProductVariants,
  CountProductsRequest,
  CountProductsResponse,
  DoNotCallBulkCreateProductsRequest,
  DoNotCallBulkCreateProductsResponse,
  V3BulkProductResult,
  CommonItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  DoNotCallBulkUpdateProductsRequest,
  MaskedProduct,
  DoNotCallBulkUpdateProductsResponse,
  BulkUpdateProductsByFilterRequest,
  BulkUpdateProductsByFilterResponse,
  BulkDeleteProductsRequest,
  BulkDeleteProductsResponse,
  BulkProductResult,
  BulkDeleteProductsByFilterRequest,
  BulkDeleteProductsByFilterResponse,
  BulkAddInfoSectionsToProductsByFilterRequest,
  BulkAddInfoSectionsToProductsByFilterResponse,
  FulfillerDeleted,
  BulkAddInfoSectionsToProductsRequest,
  ProductIdWithRevision,
  BulkAddInfoSectionsToProductsResponse,
  BulkRemoveInfoSectionsFromProductsByFilterRequest,
  BulkRemoveInfoSectionsFromProductsByFilterResponse,
  BulkRemoveInfoSectionsFromProductsRequest,
  BulkRemoveInfoSectionsFromProductsResponse,
  BulkUpdateVariantsByFilterRequest,
  BulkUpdateVariantsByFilterResponse,
  BulkAdjustProductVariantsByFilterRequest,
  AdjustValue,
  AdjustValueAdjustValueOneOf,
  UnsignedAdjustValue,
  UnsignedAdjustValueAdjustValueOneOf,
  BulkAdjustProductVariantsByFilterResponse,
  BulkCreateProductsForMigrationRequest,
  BulkCreateProductsForMigrationResponse,
  BulkInventoryItemAction,
  InventoryItem,
  InventoryItemTrackingMethodOneOf,
  PreorderInfo,
  Product,
  Brand,
  CalculateProductInventorPreorderStatusAsyncRequest,
  CalculateProductInventorPreorderStatusAsyncResponse,
  PuffUpProductMediaRequest,
  PuffUpProductMediaResponse,
  BulkUpdateProductTagsRequest,
  BulkUpdateProductTagsResponse,
  BulkUpdateProductTagsResult,
  BulkUpdateProductTagsByFilterRequest,
  BulkUpdateProductTagsByFilterResponse,
  CatalogRollbackRequested,
  CreateProductRequest,
  CreateProductResponse,
  VariantsNotAlignedWithProduct,
  VariantNotAlignedWithProduct,
  MissingVariantOptionChoiceErrorData,
  MissingVariantOptionErrorData,
  CreateProductWithInventoryRequest,
  ProductWithInventory,
  ProductWithInventoryTypedPropertiesOneOf,
  V3VariantsInfo,
  VariantWithInventory,
  VariantWithInventoryTypedPropertiesOneOf,
  InventoryItemComposite,
  InventoryItemCompositeTrackingMethodOneOf,
  OptionChoiceReferences,
  V3OptionChoiceIds,
  V3OptionChoiceNames,
  CreateProductWithInventoryResponse,
  BulkInventoryItemResults,
  BulkInventoryItemResult,
  ItemMetadata,
  CommonBulkActionMetadata,
  UpdateProductRequest,
  UpdateProductResponse,
  UpdateProductWithInventoryRequest,
  UpdateProductWithInventoryResponse,
  BulkCreateProductsRequest,
  BulkCreateProductsResponse,
  CatalogV3BulkProductResult,
  WixCommonItemMetadata,
  InvalidDigitalFileIds,
  BulkCreateProductsWithInventoryRequest,
  BulkCreateProductsWithInventoryResponse,
  BulkProductResults,
  BulkUpdateProductsRequest,
  V3MaskedProduct,
  BulkUpdateProductsResponse,
  BulkUpdateProductsWithInventoryRequest,
  MaskedProductWithInventory,
  BulkUpdateProductsWithInventoryResponse,
  V3BulkUpdateProductsByFilterRequest,
  WixCommonSearchDetails,
  V3BulkUpdateProductsByFilterResponse,
  V3DeleteProductRequest,
  V3DeleteProductResponse,
  V3BulkDeleteProductsRequest,
  V3BulkDeleteProductsResponse,
  BulkDeleteProductsResponseBulkProductResult,
  V3BulkDeleteProductsByFilterRequest,
  V3BulkDeleteProductsByFilterResponse,
  V3GetProductRequest,
  V3GetProductResponse,
  V3GetProductBySlugRequest,
  V3GetProductBySlugResponse,
  V3SearchProductsRequest,
  CommonCursorSearch,
  CommonCursorSearchPagingMethodOneOf,
  WixCommonSorting,
  WixCommonAggregation,
  WixCommonAggregationKindOneOf,
  AggregationRangeAggregationRangeBucket,
  AggregationValueAggregationIncludeMissingValuesOptions,
  CommonAggregationValueAggregation,
  CommonAggregationValueAggregationOptionsOneOf,
  CommonAggregationRangeAggregation,
  CommonAggregationScalarAggregation,
  CommonAggregationDateHistogramAggregation,
  AggregationNestedAggregationNestedAggregationItem,
  AggregationNestedAggregationNestedAggregationItemKindOneOf,
  CommonAggregationNestedAggregation,
  CommonCursorPaging,
  V3SearchProductsResponse,
  CommonCursorPagingMetadata,
  CommonCursors,
  CommonAggregationData,
  ValueResultsValueAggregationResult,
  RangeResultsRangeAggregationResult,
  AggregationResultsNestedAggregationResults,
  AggregationResultsNestedAggregationResultsResultOneOf,
  AggregationResultsValueResults,
  AggregationResultsRangeResults,
  AggregationDataAggregationResultsScalarResult,
  GroupByValueResultsNestedValueAggregationResult,
  NestedResultsValueResult,
  NestedResultsRangeResult,
  NestedResultsScalarResult,
  NestedResultsNestedResultValue,
  NestedResultsNestedResultValueResultOneOf,
  NestedResultsResults,
  DateHistogramResultsDateHistogramResult,
  AggregationResultsGroupByValueResults,
  AggregationResultsDateHistogramResults,
  AggregationResultsNestedResults,
  AggregationDataAggregationResults,
  AggregationDataAggregationResultsResultOneOf,
  V3QueryProductsRequest,
  CommonCursorQuery,
  CommonCursorQueryPagingMethodOneOf,
  V3QueryProductsResponse,
  V3CountProductsRequest,
  V3CountProductsResponse,
  BulkUpdateProductVariantsByFilterRequest,
  BulkUpdateProductVariantsByFilterResponse,
  V3BulkAdjustProductVariantsByFilterRequest,
  V3AdjustValue,
  V3AdjustValueAdjustValueOneOf,
  V3UnsignedAdjustValue,
  V3UnsignedAdjustValueAdjustValueOneOf,
  V3BulkAdjustProductVariantsByFilterResponse,
  V3BulkAddInfoSectionsToProductsByFilterRequest,
  V3BulkAddInfoSectionsToProductsByFilterResponse,
  V3BulkAddInfoSectionsToProductsRequest,
  V3ProductIdWithRevision,
  V3BulkAddInfoSectionsToProductsResponse,
  V3BulkRemoveInfoSectionsFromProductsByFilterRequest,
  V3BulkRemoveInfoSectionsFromProductsByFilterResponse,
  V3BulkRemoveInfoSectionsFromProductsRequest,
  V3BulkRemoveInfoSectionsFromProductsResponse,
  BulkCreateProductsWithInventoryForMigrationRequest,
  ProductWithInventoryForMigration,
  ProductWithInventoryForMigrationTypedPropertiesOneOf,
  VariantsInfoForMigration,
  VariantWithInventoryForMigration,
  VariantWithInventoryForMigrationTypedPropertiesOneOf,
  InventoryItemCompositeForMigration,
  InventoryItemCompositeForMigrationTrackingMethodOneOf,
  OptionChoiceReferencesForMigration,
  OptionChoiceIdsForMigration,
  BulkCreateProductsWithInventoryForMigrationResponse,
  BulkAddProductsToCategoriesByFilterRequest,
  BulkAddProductsToCategoriesByFilterResponse,
  BulkRemoveProductsFromCategoriesByFilterRequest,
  BulkRemoveProductsFromCategoriesByFilterResponse,
  GetAllProductsCategoryRequest,
  GetAllProductsCategoryResponse,
  TreeReference,
  V3BulkUpdateProductTagsRequest,
  V3BulkUpdateProductTagsResponse,
  BulkUpdateProductTagsResponseBulkUpdateProductTagsResult,
  V3BulkUpdateProductTagsByFilterRequest,
  V3BulkUpdateProductTagsByFilterResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ProductCreatedEnvelope,
  ProductDeletedEnvelope,
  ProductUpdatedEnvelope,
  CreateProductOptions,
  CreateProductWithInventoryOptions,
  UpdateProduct,
  UpdateProductOptions,
  UpdateProductWithInventoryProduct,
  UpdateProductWithInventoryOptions,
  BulkCreateProductsOptions,
  BulkCreateProductsWithInventoryOptions,
  BulkUpdateProductsOptions,
  BulkUpdateProductsWithInventoryOptions,
  BulkUpdateProductsByFilterOptions,
  BulkDeleteProductsByFilterOptions,
  GetProductOptions,
  GetProductBySlugOptions,
  SearchProductsOptions,
  V3ProductSearchSpec,
  QueryProductsOptions,
  ProductsQueryResult,
  ProductsQueryBuilder,
  V3ProductQuerySpec,
  CountProductsOptions,
  BulkUpdateProductVariantsByFilterOptions,
  BulkAdjustProductVariantsByFilterOptions,
  BulkAddInfoSectionsToProductsByFilterOptions,
  BulkAddInfoSectionsToProductsOptions,
  BulkRemoveInfoSectionsFromProductsByFilterOptions,
  BulkRemoveInfoSectionsFromProductsOptions,
  BulkAddProductsToCategoriesByFilterOptions,
  BulkRemoveProductsFromCategoriesByFilterOptions,
  BulkUpdateProductTagsOptions,
  BulkUpdateProductTagsByFilterOptions,
} from './stores-catalog-v3-product-products-v-3.universal.js';
export { utils } from './stores-catalog-v3-product-products-v-3.universal.js';
export {
  NodeTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  TypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  MediaTypeWithLiterals,
  ProductOptionRenderTypeWithLiterals,
  ChoiceTypeWithLiterals,
  ModifierRenderTypeWithLiterals,
  InventoryAvailabilityStatusWithLiterals,
  PreorderStatusWithLiterals,
  ProductPreorderAvailabilityWithLiterals,
  ProductTypeWithLiterals,
  MeasurementUnitWithLiterals,
  WeightUnitWithLiterals,
  FileTypeWithLiterals,
  SubscriptionFrequencyWithLiterals,
  DiscountTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  SketchDataVariantWithLiterals,
  OriginWithLiterals,
  BannerPositionWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  DimensionsUnitWithLiterals,
  UserCriteriaWithLiterals,
  EnumWithLiterals,
  StateWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SingleEntityOpsRequestedFieldsWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  RequestedFieldsWithLiterals,
  CommonSortOrderWithLiterals,
  ValueAggregationSortTypeWithLiterals,
  ValueAggregationSortDirectionWithLiterals,
  ValueAggregationMissingValuesWithLiterals,
  CommonScalarTypeWithLiterals,
  NestedAggregationNestedAggregationTypeWithLiterals,
  DateHistogramAggregationIntervalWithLiterals,
  CommonAggregationTypeWithLiterals,
  SearchDetailsModeWithLiterals,
  VariantsOpsRequestedFieldsWithLiterals,
  RoundingStrategyWithLiterals,
  AvailabilityStatusWithLiterals,
  EventTypeWithLiterals,
  CommonSearchDetailsModeWithLiterals,
  WixCommonSortOrderWithLiterals,
  AggregationValueAggregationSortTypeWithLiterals,
  AggregationValueAggregationSortDirectionWithLiterals,
  AggregationValueAggregationMissingValuesWithLiterals,
  WixCommonScalarTypeWithLiterals,
  AggregationNestedAggregationNestedAggregationTypeWithLiterals,
  AggregationDateHistogramAggregationIntervalWithLiterals,
  WixCommonAggregationTypeWithLiterals,
  BulkAdjustProductVariantsByFilterRequestRoundingStrategyWithLiterals,
  CreateProductApplicationErrors,
  CreateProductValidationErrors,
  CreateProductWithInventoryApplicationErrors,
  CreateProductWithInventoryValidationErrors,
  UpdateProductApplicationErrors,
  UpdateProductValidationErrors,
  UpdateProductWithInventoryApplicationErrors,
  UpdateProductWithInventoryValidationErrors,
  BulkCreateProductsApplicationErrors,
  BulkCreateProductsValidationErrors,
  BulkCreateProductsWithInventoryApplicationErrors,
  BulkCreateProductsWithInventoryValidationErrors,
  BulkUpdateProductsApplicationErrors,
  BulkUpdateProductsValidationErrors,
  BulkUpdateProductsWithInventoryApplicationErrors,
  BulkUpdateProductsWithInventoryValidationErrors,
  BulkUpdateProductsByFilterApplicationErrors,
  BulkUpdateProductsByFilterValidationErrors,
  BulkDeleteProductsValidationErrors,
  GetProductApplicationErrors,
  GetProductBySlugApplicationErrors,
  SearchProductsApplicationErrors,
  QueryProductsApplicationErrors,
  CountProductsApplicationErrors,
  BulkUpdateProductVariantsByFilterApplicationErrors,
  BulkUpdateProductVariantsByFilterValidationErrors,
  BulkAdjustProductVariantsByFilterApplicationErrors,
  BulkAdjustProductVariantsByFilterValidationErrors,
  BulkAddInfoSectionsToProductsByFilterApplicationErrors,
  BulkAddInfoSectionsToProductsApplicationErrors,
  BulkUpdateProductTagsApplicationErrors,
  BulkUpdateProductTagsByFilterApplicationErrors,
  CommonSearchWithEntityContext,
  V3ProductSearch,
  CommonQueryWithEntityContext,
  V3ProductQuery,
} from './stores-catalog-v3-product-products-v-3.universal.js';
